const hcAuthUtils = (global as any).CmAuthUtils; // NOSONAR

export default hcAuthUtils;
